<div style="display: block;background-color: white;overflow-y: auto;">
  <div class="dashboard-card-top-section">
    <div class="btn btn-group">
      <select class="btn bg-white border btn-sm" (change)="getData()" [(ngModel)]="filterType">
        <option class="dropdown-item" value="fixed">Fixed</option>
        <option class="dropdown-item" value="custom">Custom</option>
      </select>
      @if (timePeriodList && data.time_period && filterType=='fixed') {
        <select class="btn bg-white border btn-sm"
          [(ngModel)]="data.time_period" (change)="setFilter($event)">
          @for (entry of timePeriodList; track entry) {
            @if (entry.code!='custom') {
              <option class="dropdown-item" [value]="entry.code">
              {{entry.display}}</option>
            }
          }
        </select>
      }
      @if (data.interval && filterType=='fixed') {
        <select class="btn bg-white border btn-sm" [(ngModel)]="data.interval"
          (change)="setInterval($event)">
          @for (entry of intervals; track entry) {
            <option class="dropdown-item" [value]="entry">{{entry | titlecase}}
            </option>
          }
        </select>
      }
      @if (filterType=='custom') {
        <input type="text" ngxDaterangepickerMd
          class="btn bg-white border datepicker-search" placeholder="Choose date" showCancel="true"
          [singleDatePicker]="false" [autoApply]="false"
          [timePicker]="false"
          [timePickerIncrement]="1" [startKey]="'FROM'"
          [endKey]="'TO'"
          (change)="valueChange($event)" autocomplete="off" />
      }

    </div>
    @if (config.isCached) {
      <div (click)="refreshData()" class="pull-right p-3" title="Data is Cached (Refresh frequency:{{chartService.CACHE_THRESHOLD_LABEL}}), click to refresh.">
        <span class="chart_refresh"></span>
        <i class="fa fa-refresh" style="cursor: pointer;"></i>
      </div>
    }
    @if (!hideLabels) {
      <h4 class="flex-grow-1"><b>{{data.widget_name}}</b></h4>
    }
  </div>
  @if (showWidgets) {
    <div>
      @if (datasets && datasets[0] ) {
        <canvas baseChart style="cursor: pointer;" class="chart" #kxChart="base-chart" [data]="datasets[0].data" [labels]="labels" [options]="chartOptions"
        [chartType]="data.type"></canvas>
      } @else {
        <canvas baseChart class="chart" [data]="[-1]" [labels]="['Sample']"
        [chartType]="data.type" [colors]="['grey']"></canvas>
      }
    </div>
  }
</div>